export const VENTA_COMPROBANTE = 1;
export const VENTAS_COTIZACION = 2;
export const VENTAS_GUIA_REMISION = 3;
export const LOGISTICA_COMPRA = 4;
export const LOGISTICA_REQUERIMIENTO = 6;
export const LOGISTICA_ORDEN_COMPRA = 7;
export const LOGISTICA_ORDEN_SERVICIO = 8;

export const VENTAS_PEDIDO = 9;
export const LOGISTICA_ORDEN_PRODUCCION = 13;